import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarFornecedor from '../../components/modal/ModalCadastrarFornecedor';
import ModalEditarFornecedor from '../../components/modal/ModalEditarFornecedor';
import ModalExcluirFornecedor from '../../components/modal/ModalExcluirFornecedor';
import { ServicoContext } from '../../context/ServicoContext';
import Tabela from '../../components/Tabela';

function Fornecedor() {
    const { Success, Error, openModal, setOpenModal, FornecedoresConsulta, ListaFornecedorConsulta, loading, modalEditarFornecedor, setModalEditarFornecedor, setEdicaoFornecedor, setFornecedorAtualKey, modalExcluirFornecedor, setModalExcluirFornecedor, InativarFornecedor, ListaFiltroFornecedor, totalRegistrosFornecedor, filtroFornecedor, totalRegistrosFiltroFornecedor } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");


    const EditFornecedor = (props) => {
        setModalEditarFornecedor(true)
        setFornecedorAtualKey(props.key)
        setEdicaoFornecedor(props)
    }

    const DeletarFornecedor = (props) => {
        setFornecedorAtualKey(props.key)
        setModalExcluirFornecedor(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroFornecedor(searchTerm, currentPage, pageSize);
        } else {
            ListaFornecedorConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroFornecedor : totalRegistrosFornecedor;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar fornecedores'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarFornecedor &&
                <ModalEditarFornecedor currentPage={currentPage} />
            }
            {modalExcluirFornecedor &&
                <ModalExcluirFornecedor currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarFornecedor closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar fornecedor</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Fornecedores cadastrados</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroFornecedor : FornecedoresConsulta}
                            columns={[
                                { label: "Fantasia", field: "fantasia", width: "30%" },
                                { label: "Site", field: "site", width: "30%", render: (x) => x.site || "-" },
                                { label: "Telefone", field: "telefone", width: "20%", render: (x) => x.telefone || "-" },
                                {
                                    label: "Ativo",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                            <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarFornecedor(x.key, !x.ativo)} checked={x.ativo} />
                                        </div>
                                    ),
                                },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditFornecedor(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarFornecedor(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroFornecedor(term, 1, 10);
                                } else {
                                    ListaFornecedorConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Fornecedor;